import { object, string } from 'yup';

import { CATEGORY_SUB_TYPES } from '../constants';

export interface NotificationContent {
  title: string;
  description: string;
  buttonText: string;
  link: string;
}

export interface MetadataEntry {
  key: string;
  value: string;
}

export interface BroadcastFormValues {
  categorySubType: string;
  isPinned: boolean;
  iconId: string;
  content: NotificationContent;
  metadata: MetadataEntry[];
}

export const initialValues: BroadcastFormValues = {
  categorySubType: CATEGORY_SUB_TYPES[0].value,
  isPinned: false,
  iconId: '',
  content: { title: '', description: '', buttonText: '', link: '' },
  metadata: [],
};

export const validationSchema = object().shape({
  iconId: string().required('Icon is required'),
  categorySubType: string().trim().required('Category Sub Type is required'),
  content: object().shape({
    title: string().trim().required('Title is required'),
    description: string().trim().required('Description is required'),
    buttonText: string().trim().required('Button Text is required'),
    link: string().trim().required('Link is required'),
  }),
});
